import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type {
  HandlersBulkSimPauseResumeResponse,
  StructsSimRequestProperties,
} from 'types/__generated__/SimInventoryApi';
import type { SimInventoryBulkStateAction } from 'types/common';

interface UseBulkStateChangeCallProps {
  organizationId?: OrgId;
  action: SimInventoryBulkStateAction;
  preview?: boolean;
}

const useBulkStateChangeCall = ({
  organizationId,
  action,
  preview,
}: UseBulkStateChangeCallProps) => {
  const url = organizationId
    ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${action}${preview ? '/preview' : ''}`
    : null;

  const callback = useCallback(
    async (sims: Array<HologramSimId>) => {
      if (!url) {
        return undefined;
      }

      const body: StructsSimRequestProperties = {
        organizationId: organizationId!, // Url set means organizationId is set
        hologramSimIds: sims,
      };

      const result: HandlersBulkSimPauseResumeResponse | undefined = await postFetcher({
        url,
        body,
      });

      return result;
    },
    [organizationId, url]
  );

  return callback;
};

export default useBulkStateChangeCall;
